import Vue from 'vue'
import vuetify from './plugins/vuetify'
import { VApp } from "vuetify/lib";
import axios from "axios";
import vueCustomElement from 'vue-custom-element'
import CcresVisuMwr from "./components/CcresVisuMwr"

// Vue.prototype.$prodPrefix = "http://localhost:8080/"

Vue.use(vueCustomElement);
Vue.use(axios);



Vue.customElement('ccres-visu-mwr', {
  vuetify: vuetify,
  components: { VApp, CcresVisuMwr },
  template: `<v-app id='app'><ccres-visu-mwr></ccres-visu-mwr></v-app>`
})




// npm run build -- --target lib --name ccres-visu-mwr src/main.production.mwr.js